<div mat-dialog-content>
    <h1>TuGessi</h1>
    <h2 *ngIf="data.error">Error</h2>
    <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
    <button *ngIf="data.hasCancel" mat-button (click)="onCancel()">Cancelar</button>
    <button mat-button (click)="onOk()"> Ok</button>
</div>